var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordicSmsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.163,
    height: 31.697,
    viewBox: "0 0 33.163 31.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(-34.747 -525.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-right-text",
    transform: "translate(34.747 525.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M4.145,2.073H29.018A2.073,2.073,0,0,1,31.09,4.145V28.16l-4.145-4.145a4.145,4.145,0,0,0-2.93-1.215H4.145a2.073,2.073,0,0,1-2.073-2.073V4.145A2.073,2.073,0,0,1,4.145,2.073ZM29.018,0a4.145,4.145,0,0,1,4.145,4.145V30.661a1.036,1.036,0,0,1-1.77.731L25.48,25.479a2.073,2.073,0,0,0-1.466-.607H4.145A4.145,4.145,0,0,1,0,20.727V4.145A4.145,4.145,0,0,1,4.145,0Z",
    fill: "#575651",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M6.75,12.968a1.036,1.036,0,0,1,1.036-1.036H26.441a1.036,1.036,0,0,1,0,2.073H7.786A1.036,1.036,0,0,1,6.75,12.968Zm0,5.182a1.036,1.036,0,0,1,1.036-1.036H18.15a1.036,1.036,0,1,1,0,2.073H7.786A1.036,1.036,0,0,1,6.75,18.15Z",
    transform: "translate(-0.532 -0.532)",
    fill: "#575651",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 12.541,
    transform: "translate(41.87 532.349)",
    fill: "none",
    stroke: "#7d6630",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "* ",
    transform: "matrix(-1, 0, 0, 1, 59.911, 527.849)",
    fill: "#7d6630",
    fontSize: 7,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "* ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicSmsActive);
export default __webpack_public_path__ + "static/media/nordic_sms_active.0bf34662283fb7c2ea2ae3004b700e3f.svg";
export { ForwardRef as ReactComponent };